import { render, staticRenderFns } from "./Qiang.vue?vue&type=template&id=79ca3c2a&scoped=true&"
import script from "./Qiang.vue?vue&type=script&lang=js&"
export * from "./Qiang.vue?vue&type=script&lang=js&"
import style0 from "./Qiang.vue?vue&type=style&index=0&id=79ca3c2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79ca3c2a",
  null
  
)

export default component.exports